export type LoadScriptOptions = Partial<Pick<HTMLScriptElement, 'id' | 'async'>>;

/**
 * loadScript is accepting src files with no extenstion
 */
export const loadScript = (src: string, options: LoadScriptOptions = {}) =>
  new Promise<void>((resolve, reject) => {
    const scriptEl = document.createElement('script');

    scriptEl.async = options.async ?? true;
    scriptEl.addEventListener('load', () => resolve(), { once: true });
    scriptEl.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });

    if (options.id) scriptEl.id = options.id;
    scriptEl.src = src;

    document.body.appendChild(scriptEl);
  });

export default loadScript;
